import {
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import { codeliveDropdownMenuProps } from './dropdownMenuProps';

export interface SingleSelectOption {
  value: string;
  label: string;
}

interface SingleSelectDropdownProps {
  options: SingleSelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function SingleSelectDropdown({
  options,
  value,
  onChange,
  placeholder = 'Select…',
  disabled = false,
  className = '',
}: SingleSelectDropdownProps) {
  const labelByValue = Object.fromEntries(options.map((o) => [o.value, o.label]));

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth size="small" className={className} disabled={disabled}>
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        input={<OutlinedInput />}
        MenuProps={codeliveDropdownMenuProps}
        renderValue={(selected) => {
          if (!selected) {
            return <span className="text-muted">{placeholder}</span>;
          }
          return labelByValue[selected] || selected;
        }}
      >
        <MenuItem value="">
          <ListItemText primary={placeholder} />
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
